module.exports = __webpack_public_path__ + "img/placard_03.297a6ad6.png";